import { useEffect, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from '@components/Toggle/styles';
import { en, he } from '@containers/LocaleToggle/consts';
import { getFromLocalStorage, setToLocalStorage, LOCAL_STORAGE_ITEM } from '@utils/localStorageHelper';

const PreAuthLocaleToggle = () => {
  const { i18n } = useTranslation();

  const changeLocale = (event: ChangeEvent<HTMLSelectElement>) => {
    const locale = event.target.value;
    i18n.changeLanguage(locale);
    setToLocalStorage(LOCAL_STORAGE_ITEM.LOCALE, locale);
  };

  useEffect(() => {
    const initialLocale = getFromLocalStorage(LOCAL_STORAGE_ITEM.LOCALE);
    const locale = initialLocale || navigator.languages?.[0] || navigator.language || en;
    i18n.changeLanguage(locale.toLowerCase());
  }, []);

  return (
    <Select
      value={i18n.language}
      onChange={changeLocale}
      style={{
        alignSelf: 'flex-end',
        position: 'absolute',
        top: 16,
        right: 16,
      }}
    >
      <option value={en}>English</option>
      <option value={he}>עברית</option>
    </Select>
  );
};

export default PreAuthLocaleToggle;
